module.exports = __webpack_public_path__ + "media/images/backgrounds/glin-symbol-black-54a62022788827c184b4b0c5bdad4134.png";